"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_CodeSystem_Property1 = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Coding_1 = require("./RTTI_Coding");
exports.RTTI_CodeSystem_Property1 = t.recursion('ICodeSystem_Property1', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        code: RTTI_code_1.RTTI_code,
        _code: RTTI_Element_1.RTTI_Element,
        valueCode: t.string,
        _valueCode: RTTI_Element_1.RTTI_Element,
        valueCoding: RTTI_Coding_1.RTTI_Coding,
        valueString: t.string,
        _valueString: RTTI_Element_1.RTTI_Element,
        valueInteger: t.number,
        _valueInteger: RTTI_Element_1.RTTI_Element,
        valueBoolean: t.boolean,
        _valueBoolean: RTTI_Element_1.RTTI_Element,
        valueDateTime: t.string,
        _valueDateTime: RTTI_Element_1.RTTI_Element,
        valueDecimal: t.number,
        _valueDecimal: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_CodeSystem_Property1.js.map